(() => {
  const source = document.currentScript;
  const dialog = document.getElementById('lnt-account-gate');
  if (!source || !dialog || window.LNTAccountGate) return;

  let itemCount = Number(source.dataset.cartCount) || 0;
  let pending = false;
  const login = dialog.querySelector('[data-lnt-gate-login]');
  const nativeFetch = window.fetch;
  const root = source.dataset.cartRoot;
  const message = source.dataset.requiredMessage;
  const pendingMessage = source.dataset.pendingMessage;

  function show() {
    if (itemCount < 1) return;
    document.querySelectorAll('cart-drawer.active').forEach((drawer) => {
      if (typeof drawer.close === 'function') drawer.close();
    });
    document.documentElement.classList.add('lnt-account-gate-open');
    if (!dialog.open) {
      if (typeof dialog.showModal !== 'function') {
        window.location.assign(login.href);
        return;
      }
      dialog.showModal();
      login.focus({ preventScroll: true });
    }
  }

  function blockedResponse(text) {
    return new Response(JSON.stringify({ status: 422, message: text, description: text }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function cartRequest(input, options) {
    try {
      const value = input instanceof Request ? input.url : String(input);
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin) return null;
      const match = url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/);
      const method = String(options?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
      return match && method !== 'GET' && method !== 'HEAD' ? match[1] : null;
    } catch {
      return null;
    }
  }

  window.LNTAccountGate = {
    get required() { return itemCount > 0; },
    show
  };

  window.fetch = async function(input, options) {
    const action = cartRequest(input, options);
    if (!action) return nativeFetch.apply(this, arguments);
    if (itemCount > 0) {
      show();
      return blockedResponse(message);
    }
    if (pending) return blockedResponse(pendingMessage);
    pending = true;
    try {
      const current = await nativeFetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!current.ok) return blockedResponse(pendingMessage);
      const cart = await current.json();
      itemCount = Number(cart.item_count) || 0;
      if (itemCount > 0) {
        show();
        return blockedResponse(message);
      }
      const response = await nativeFetch.apply(this, arguments);
      if (response.ok) {
        let data;
        try { data = await response.clone().json(); } catch {}
        if (!data?.status || Number(data.status) < 400) {
          itemCount = typeof data?.item_count === 'number' ? data.item_count : action === 'add' ? 1 : 0;
          show();
        }
      }
      return response;
    } finally {
      pending = false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || itemCount < 1) return;
    const url = new URL(form.action, window.location.href);
    if (url.origin !== window.location.origin) return;
    if (/\/cart(?:\/(?:add|change|update|clear)(?:\.js)?)?\/?$/.test(url.pathname) ||
        event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      show();
    }
  }, true);

  dialog.addEventListener('cancel', (event) => event.preventDefault());
  dialog.addEventListener('close', () => {
    if (itemCount > 0) queueMicrotask(show);
  });
  document.addEventListener('cart:updated', show);
  window.addEventListener('cart:updated', show);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
    else show();
  });
  show();
})();
